// Convert object to query string
export const objectToQueryString = (params) => {
  const queryString = [];
  for (const key in params) {
    const value = params[key];
    if (value !== undefined && value !== null && value !== "") {
      // Check for empty values
      if (Array.isArray(value)) {
        value.forEach((item) => {
          queryString.push(
            `${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`
          );
        });
      } else {
        queryString.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        );
      }
    }
  }
  return queryString.join("&");
};
